import { useTranslation } from 'react-i18next';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import type { V4Subscription } from '../../types';

interface SubscriptionDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  contract: V4Subscription | null;
  onConfirm: () => void;
  isLoading?: boolean;
}

export function SubscriptionDeleteDialog({
  open,
  onOpenChange,
  contract,
  onConfirm,
  isLoading,
}: SubscriptionDeleteDialogProps) {
  const { t } = useTranslation('subscriptions');

  if (!contract) return null;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('delete.title')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('delete.message')}
            <br />
            <strong>{t('delete.contractLabel')}</strong> #{contract.subscriptionNumber}
            {contract.name && (
              <>
                <br />
                <strong>{t('delete.nameLabel')}</strong> {contract.name}
              </>
            )}
            <br />
            <strong>{t('delete.customerLabel')}</strong> {contract.accountName || '—'}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>{t('delete.cancel')}</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isLoading}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isLoading ? t('delete.deleting') : t('delete.confirm')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
